import { BookingItem } from '../../../types/Booking';

export function hasFile(booking: BookingItem): boolean {
  return booking.files ? booking.files.length > 0 : false;
}
